import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import {
  Verification,
  VerificationApprove,
} from './types'
import { $params } from '../../../features/router'

export const verificationRequestMounted = createEvent()
export const setverificationRequest = createEvent<Verification>()
export const $verificationRequest = restore(setverificationRequest, {
  clientId: '',
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',
  requestId: '',
  status: '',
  country: '',
  city: '',
  address: '',
  zip: '',
  documentType: '',
  fileNames: [],
  browserFileNames: [],
  exampleFiles: '',
  expirationDate: '',
  isDuplicate: false,
  profileNotes: '',
  reason: '',
  previousReason: '',
  comment: '',
  client: {
    clientId: '0',
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    verified: false,
    country: '',
    fullName: '',
    hasDeposit: false,
    partner: false,
    registeredAt: '',
    address: '',
    phone: '',
    dateOfBirth: '',
    socialNetwork: '',
    avatarUrl: '',
    gender: '',
    isTest: false,
  },
  manager: {
    id: '',
    user: {
      email: '',
      fullName: '',
    },
  },
})
export const submitApprove = createEvent<VerificationApprove>()
export const approveVerification = fx<Record<string, never>, Verification>(
  {
    method: 'POST',
    url: `/verification/`,
  },
)

sample({
  clock: submitApprove,
  fn: ({ requestId }) => {
    return {
      body: {},
      url: `/verification/${requestId}/accept`,
    }
  },
  target: approveVerification,
})
export const getVerification = fx<void, Verification>({
  method: 'GET',
  url: '/verification/',
})

sample({
  clock: verificationRequestMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.verificationsID
    }
    return {
      url: `/verification/${id}`,
    }
  },
  target: getVerification,
})

// update profile model

sample({
  clock: getVerification.doneData,
  fn: (doneData) => doneData.body,
  target: setverificationRequest,
})
